import { mutatorAction } from 'satcheljs';
import { OwaSessionStore } from '../store/schema/OwaSessionStore';
import { getStore } from '../store/store';

// REFLOW TECHNICAL DEBT: The setOwaSessionStoreInternal allows for the whole store to be
// set when the selected account is changed
export const setOwaSessionStoreInternal = mutatorAction(
    'setOwaSessionStore',
    (sessionStore: OwaSessionStore) => {
        const store = getStore();

        store.accountScopeUserSettingsMap = sessionStore.accountScopeUserSettingsMap;
        store.userConfiguration = sessionStore.userConfiguration;

        store.connectedAccountsUserConfigurationMap =
            sessionStore.connectedAccountsUserConfigurationMap;
        store.defaultFolderIdToNameMap = sessionStore.defaultFolderIdToNameMap;
        store.defaultFolderNameToIdMap = sessionStore.defaultFolderNameToIdMap;
    }
);
